import { NgClass } from '@angular/common';
import { Component, ViewEncapsulation, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ServicemeshConfirmationConfig } from '@helpers/services/confirmation/confirmation.types';

@Component({
  selector: 'servicemesh-confirmation-dialog',
  templateUrl: './dialog.component.html',
  styles: [
    `
      @reference '../../../styles/tailwind.css';

      .servicemesh-confirmation-dialog-panel {
        @media (min-width: 960px) {
          @apply w-128;
        }

        .mat-mdc-dialog-container {
          .mat-mdc-dialog-surface {
            padding: 0 !important;
          }
        }
      }
    `,
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, MatIconModule, NgClass],
})
export class ServicemeshConfirmationDialogComponent {
  data = inject<ServicemeshConfirmationConfig>(MAT_DIALOG_DATA);
}
